module.exports = __webpack_public_path__ + "static/media/truck-repair.8bdd0d27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealerFeatures/truck-repair.svg
// module id = 2554
// module chunks = 2